import React, {useState} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import reviewBuilderUploadsApi from "../../../../components/uploadgallery/reviewBuilderGalleryApi";
import UploadGalleryStore from "../../../../components/uploadgallery/uploadGalleryStore";
import UploadGallery from "../../../../components/uploadgallery/UploadGallery";


function BulkLocationEditorImages ({locationPatch, updateImageUrls, updateLogoUrl}) {

  const [logoImageSelectorOpen, setLogoImageSelectorOpen] = useState(false);

  const [generalImageSelectorOpen, setGeneralImageSelectorOpen] = useState(false);

  const [uploadGalleryStore, setUploadGalleryStore] = useState(new UploadGalleryStore(reviewBuilderUploadsApi));

  const setLogo = (logoUrl) => {
    setLogoImageSelectorOpen(false);
    updateLogoUrl(logoUrl)
  };

  const unsetLogo = () => {
    updateLogoUrl(null)
  };

  const addGeneralImage = (imageUrl) => {
    setGeneralImageSelectorOpen(false);
    updateImageUrls(locationPatch.listingManagementSpecs.imageUrls.concat([imageUrl]))
  };

  const removeGeneralImage = (imageUrl) => {
    updateImageUrls(locationPatch.listingManagementSpecs.imageUrls.filter(url => url !== imageUrl))
  };

  return <div className="card-spacer-top card-spacer-bottom">
      <h5>Set Logo</h5>
      <div className="row card-spacer-top">
        {!!locationPatch.listingManagementSpecs.logoUrl && <div className="col-4 col-sm-4"><div className="img-gallery-item">
          <div className="text-center overflow-hidden">
            <img src={locationPatch.listingManagementSpecs.logoUrl} style={{"height": "100px"}}/>
          </div>
          <div className="text-center" style={{"marginTop": "3px"}}>
            <a onClick={unsetLogo} href="javascript:void(0)" style={{textDecoration: 'underline'}}>Remove</a>
          </div>
        </div>
        </div>}
        {!locationPatch.listingManagementSpecs.logoUrl && <div className="col-4 col-sm-4">
          <div className="img-gallery-item">
            <div className="text-center overflow-hidden">
              <div style={{"height": "91px", "opacity": "0"}}/>{/* Spacer to match height of uploaded images */}
              <button type="button" className="btn btn-secondary" onClick={() => setLogoImageSelectorOpen(true)}>
                <i className="far fa-plus" />
              </button>
            </div>
          </div>
        </div>}
      </div>
    {logoImageSelectorOpen && <Modal isOpen={true} toggle={() => setLogoImageSelectorOpen(false)} className="modal-lg">
      <ModalHeader toggle={() => setLogoImageSelectorOpen(false)}>Select or Upload a Logo Image</ModalHeader>
      <ModalBody>
        <UploadGallery uploadGalleryStore={uploadGalleryStore} imageSelectedCallback={image => setLogo(image.url)}/>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-secondary" onClick={() => setLogoImageSelectorOpen(false)}>Cancel</button>{" "}
      </ModalFooter>
    </Modal>}


    <h5 className="content-spacer-top">Add General Images</h5>
    <div>There is a maximum of 25 photos, including those already saved to locations. When the maximum of 25 is exceeded, the most recently added ones will be kept and the oldest ones will be discarded from each location.</div>
    <div className="row card-spacer-top">
      {locationPatch.listingManagementSpecs.imageUrls.map(imageUrl => {
        return <div className="col-4 col-sm-4"><div className="img-gallery-item">
          <div className="text-center overflow-hidden">
            <img src={imageUrl} style={{"height": "100px"}}/>
          </div>
          <div className="text-center" style={{"marginTop": "3px"}}>
            <a onClick={() => removeGeneralImage(imageUrl)} href="javascript:void(0)" style={{textDecoration: 'underline'}}>Remove</a>
          </div>
        </div>
        </div>
      })}
      {locationPatch.listingManagementSpecs.imageUrls.length < 25 && <div className="col-4 col-sm-4">
        <div className="img-gallery-item">
          <div className="text-center overflow-hidden">
            <div style={{"height": "91px", "opacity": "0"}}/>{/* Spacer to match height of uploaded images */}
            <button type="button" className="btn btn-secondary" onClick={() => setGeneralImageSelectorOpen(true)}>
              <i className="far fa-plus" />
            </button>
          </div>
        </div>
      </div>}
    </div>
    {generalImageSelectorOpen && <Modal isOpen={true} toggle={() => setGeneralImageSelectorOpen(false)} className="modal-lg">
      <ModalHeader toggle={() => setGeneralImageSelectorOpen(false)}>Select or Upload a General Image</ModalHeader>
      <ModalBody>
        <UploadGallery uploadGalleryStore={uploadGalleryStore} imageSelectedCallback={image => addGeneralImage(image.url)}/>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-secondary" onClick={() => setGeneralImageSelectorOpen(false)}>Cancel</button>{" "}
      </ModalFooter>
    </Modal>}
  </div>
}

export default BulkLocationEditorImages;